<script setup lang="ts">
const auth = useAuth()
</script>

<template>
  <div :class="$style.user" class="_col _align-start _gap08">
    <UiLoadingBox v-if="auth.loading" width="_w220" height="_h28" />
    <div v-else class="m_pl1">
      <h2 v-if="auth._fullname" :class="$style.h2" class="m_fs17">{{ auth._fullname }}</h2>
      <div class="_fs09 _pt04 _c4">{{ auth.email }}</div>
    </div>

    <ClientOnly>
      <LazyAppSideMenuB2B v-if="auth.isB2B" />
    </ClientOnly>

    <div v-if="auth.isAuth" class="_pt1">
      <AppLogout />
    </div>
  </div>
</template>

<style module>
.user {
  min-height: calc(80px + var(--fs-24));
}
</style>
